import React, { createContext } from "react";
import { Link } from "react-router-dom";

import "./Tetrad.css";

function Tetrad() {
  return (
    <div className="tetrad">
        <div className="tetrad__container">
        <form>
            <div className="forma__container">
              <fieldset>
                <legend> ФОРМА ВВОДА </legend>
                <div>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Имя*"
                    required
                    aria-required="true"
                    disabled
                  />
                </div>
                <div>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Email*"
                    required
                    aria-required="true"
                    disabled
                  />
                </div>
                <div>
                  <input
                    id="phone"
                    name="phone"
                    type="phone"
                    placeholder="Телефон*"
                    required
                    aria-required="true"
                    disabled
                  />
                </div>
                <div>
                  <input
                    id="message"
                    name="message"
                    type="text"
                    placeholder="Сообщение*"
                    required
                    aria-required="true"
                    disabled
                  />
                </div>
                <div>
                  <input
                    id="checkbox"
                    name="checkbox"
                    type="checkbox"
                    placeholder="Сообщение*"
                    required
                    disabled
                  />
                  <label> Согласие </label>
                </div>
              </fieldset>
            </div>
        </form>
        </div>
    </div>
  );
}

export default Tetrad;
